<style scoped lang="less">
	@import url('../../assets/less/base.less');
	.common-nav-box {
		position: absolute;
		left: 0;
		width: 180px;
		height: 100%;
		min-height: 700px;
		background: #f5f5f5;
		color: #fff;
		padding-top: 90px;
		a {
			display: block;
			color: @default-commonGray;
		}
	}
</style>
<template>
	<div class="common-nav-box lt">
		<el-row class="tac">
			<el-col>
				<el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="handleSelect" background-color="#f5f5f5" text-color="#333" active-text-color="#4a7ae6">
					<el-menu-item index="/index">
						<router-link to="/index" tag="a">
							<i class="icon icon-home"></i>
							<span>首页</span>
						</router-link>
					</el-menu-item>
					<el-submenu index="/mediaManage">
						<template slot="title">
							<i class="icon icon-media"></i>
							<span>媒体管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/mediaManage/appList">
								<i class="line"></i>
								<router-link to="/mediaManage/appList" tag="a">媒体列表</router-link>
							</el-menu-item>
							<el-menu-item index="/mediaManage/advertList">
								<i class="line"></i>
								<router-link to="/mediaManage/advertList" tag="a">广告位列表</router-link>
							</el-menu-item>
							<el-menu-item index="/mediaManage/deliveryRestrictList">
								<i class="line"></i>
								<router-link to="/mediaManage/deliveryRestrictList" tag="a">投放限制</router-link>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="/statistics">
						<template slot="title">
							<i class="icon icon-data"></i>
							<span>数据统计</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/statistics/mediaData">
								<i class="line"></i>
								<router-link to="/statistics/mediaData" tag="a">媒体数据</router-link>
							</el-menu-item>
							<el-menu-item index="/statistics/advertData">
								<i class="line"></i>
								<router-link to="/statistics/advertData" tag="a">广告位数据</router-link>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					<el-submenu index="/finance">
						<template slot="title">
							<i class="icon icon-card"></i>
							<span>财务管理</span>
						</template>
						<el-menu-item-group>
							<el-menu-item index="/finance/financeInfo">
								<i class="line"></i>
								<router-link to="/finance/financeInfo" tag="a">财务信息</router-link>
							</el-menu-item>
							<el-menu-item index="/finance/depositRecord">
								<i class="line"></i>
								<router-link to="/finance/depositRecord" tag="a">提现记录</router-link>
							</el-menu-item>
						</el-menu-item-group>
					</el-submenu>
					<el-menu-item index="/sdkdown">
						<router-link to="/sdkdown" tag="a">
							<i class="icon icon-sdk"></i>
							<span>SDK下载</span>
						</router-link>
					</el-menu-item>
					<el-menu-item index="/documents">
						<router-link to="/documents" tag="a">
							<i class="icon icon-doc"></i>
							<span>文档对接</span>
						</router-link>
					</el-menu-item>
				</el-menu>
			</el-col>
		</el-row>
	</div>

</template>
<script>
	import eventBus from '../../eventBus/eventBus.js'
	export default {
		components: {

		},
		props: {},
		data() {
			return {
				activeIndex: '/index',
				//左侧导航固定显示的路由激活项,子路若要保证导航选中状态，需在下面对应url基础上设置，
				//例如媒体列表下的子页面——＞'/mediaManage/appList/叉叉叉'
				// ps: 注意大小写一致
				navList: ['/index', '/mediaManage/appList', '/mediaManage/advertList', '/mediaManage/deliveryRestrictList', '/mediaManage/appList', '/statistics/mediaData', '/statistics/advertData', '/finance/financeInfo', '/finance/depositRecord', '/documents', '/sdkdown'],
			};
		},
		watch: {
			// 如果路由有变化，显示对应导航
			"$route": function(to, from) {
				let curPath = to.path;
				let activeURl = this.setActiveNav(curPath);
				this.activeIndex = activeURl;

			}
		},
		methods: {
			handleSelect(key, keyPath) {
				//console.log(key, keyPath);
			},
			setActiveNav(url) {
				url = url || '/index';
				//返回该激活的项导航index
				let fixedNavList = this.navList;
				for(let i = 0; i < fixedNavList.length; i++) {
					if(url.indexOf(fixedNavList[i]) != -1) {
						return this.navList[i];
					}
				}
			},
		},
		created() {

		},
		mounted() {
			//重置导航激活项
			let pathURl = this.setActiveNav(this.$route.path);
			this.activeIndex = pathURl;
		}
	};
	//68
</script>



// WEBPACK FOOTER //
// src/pages/CommonNav/CommonNav.vue